type Props = {
  justify?: string;
  align?: string;
  gap?: string;
  children: any;
  direction?: "row" | "column" | "row-reverse" | "column-reverse";
  className?: string;
  style?: React.CSSProperties;
  noWrap?: boolean;
  onClick?: (e: any) => void;
  fullWidth?: boolean;
};

export const FlexContent = ({
  justify = "",
  align = "",
  children,
  gap = "",
  direction = "row",
  className,
  noWrap,
  style,
  onClick,
  fullWidth = true,
}: Props) => {
  return (
    <div
      onClick={onClick}
      className={className}
      style={{
        width: fullWidth ? "100%" : undefined,
        display: "flex",
        justifyContent: justify,
        alignItems: align,
        gap,
        flexDirection: direction,
        ...(noWrap ? { wrap: "no-wrap" } : {}),
        ...style,
      }}>
      {children}
    </div>
  );
};
